import { ScopeContext } from '@sentry/core';

import { isProductionEnvironment } from './isProductionEnvironment';
import { logToExternalErrorHandlers } from './logToExternalErrorHandlers';

export const throwErrorUnlessProduction = (error: unknown, captureOptions?: Partial<ScopeContext>): void => {
    if (!isProductionEnvironment()) {
        /* oxlint-disable-next-line no-console */
        console.error({ error, captureOptions });
        // Node has no `alert`; the console line and the throw carry the message there.
        const browserGlobals = globalThis as { alert?: (message: unknown) => void };
        if (typeof browserGlobals.alert === 'function') {
            browserGlobals.alert(error);
        }
        throw error;
    }
    if (isProductionEnvironment()) {
        logToExternalErrorHandlers(new Error(String(error)), captureOptions);
    }
};
